




























































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import vSelect from 'vue-select';
import User from '@/core/interfaces/User';
import UserGroup from '@/core/interfaces/UserGroup';
import VehicleType from '@/core/interfaces/VehicleType';
import Role from '@/core/interfaces/Role';
import FarmGroup from '@/core/interfaces/FarmGroup';
import Farm from '@/core/interfaces/Farm';

interface FarmAccessItem {
    group: UserGroup;
    roles: Role[];
    vehicleTypes: VehicleType[];
}

@Component({ components: { vSelect } })
export default class UserPermissionTree extends Vue {
    @Prop({ required: true })
    user!: User;

    selectedFarmId: number | null = null;

    @Getter('farmOptions')
    farmOptions!: { label: string; value: number }[];

    @Getter('farmById')
    farmById!: (id: number) => Farm | null;

    @Getter('userGroupsByUser')
    userGroupsByUser!: (userId: number) => UserGroup[];

    @Getter('vehicleTypesByUserGroup')
    vehicleTypesByUserGroup!: (userGroupId: number) => VehicleType[];

    @Getter('rolesByUserGroup')
    rolesByUserGroup!: (userGroupId: number) => Role[];

    @Getter('farmGroupsByUserGroup')
    farmGroupsByUserGroup!: (userGroupId: number) => FarmGroup[];

    @Getter('farmsByFarmGroup')
    farmsByFarmGroup!: (farmGroupId: number) => Farm[];

    @Getter('farmGroupsByFarm')
    farmGroupsByFarm!: (farmId: number) => FarmGroup[];

    @Getter('userGroupsByFarmGroup')
    userGroupsByFarmGroup!: (farmGroupId: number) => UserGroup[];

    get selectedFarmName(): string {
        if (this.selectedFarmId === null) return '';
        const farm = this.farmById(this.selectedFarmId);
        return farm ? farm.name : '';
    }

    get farmAccessGroups(): FarmAccessItem[] {
        if (this.selectedFarmId === null) return [];

        const userGroupIds = new Set(this.userGroupsByUser(this.user.id).map(g => g.id));

        return this.farmGroupsByFarm(this.selectedFarmId)
            .flatMap(fg => this.userGroupsByFarmGroup(fg.id))
            .filter(ug => userGroupIds.has(ug.id))
            .reduce((acc: FarmAccessItem[], ug) => {
                if (!acc.some(item => item.group.id === ug.id)) {
                    acc.push({
                        group: ug,
                        roles: this.rolesByUserGroup(ug.id),
                        vehicleTypes: this.vehicleTypesByUserGroup(ug.id),
                    });
                }
                return acc;
            }, [])
            .sort((a, b) => a.group.name.localeCompare(b.group.name));
    }
}
